<template>
  <div class="account-page">
<div class="main-wrapper">
  <layout-header></layout-header>
  <div class="main_home_content">
<div class="container">
  <div class="row">
    <div class="col-md-10 offset-md-1 pt-5 pb-5">
      <!-- Login Tab Content -->
      <div class="home-content">
        <div class="row align-items-center justify-content-center">
          <div class="col-md-7 col-lg-6">
            <h1 :style="{ marginTop: '20px' }">
              Digital Storage and Management of Medical Records and Vital
              Signs
            </h1>
            <h3 :style="{ marginTop: '20px' }">
              A Digital Revolution in Medical Record Keeping
            </h3>
            <h5 :style="{ marginTop: '20px' }">
              {{main_data}} Centralized System for Storing and
              Managing Medical Data
            </h5>
            <p :style="{ marginTop: '20px' }">
              In the age of digital transformation, accessing and managing a
              patient's medical records and vital signs shouldn't require
              sifting through piles of paperwork. {{main_data}}
              introduces a comprehensive digital system that centralizes and
              streamlines the storage and management of all medical data,
              ensuring quick access and efficient patient care.
            </p>
          </div>
          <div class="col-md-12 col-lg-5">
            <img style="height: 400px;"
              src="@/assets/img/digital_storage.jpeg"
              class="img-fluid"
              alt="Doccure Login"
            />
          </div>
        </div>
      </div>
      <!-- /Login Tab Content -->
    </div>
  </div>
</div>

<!--Key Feature  Section-->
<div class="row">
  <div class="col-md-10 offset-md-1">
    <h2
      class="first_section_heading pb-6 pt-6"
      align="center"
      style="margin-top: 30px; margin-bottom: 50px;"
    >
      Key Features
    </h2>
    <b-card-group deck>
      <b-card
        border-variant="dark"
        header="Centralized Digital Repository"
        header-bg-variant="dark"
        header-text-variant="white"
      >
        <h4>All Your Medical Data in One Place</h4>
        <b-card-text
          >Store all medical records, from consultation notes to lab
          reports, in a centralized digital system. No more misplaced
          documents or time-consuming searches.</b-card-text
        >
      </b-card>
      <b-card
        border-variant="dark"
        header="Real-Time Vital Sign Monitoring"
        header-bg-variant="dark"
        header-text-variant="white"
      >
        <h4>Stay Updated with Real-Time Dat</h4>
        <b-card-text
          >Record and monitor vital signs in real-time, ensuring timely
          interventions and continuous monitoring of patient
          health.</b-card-text
        >
      </b-card>
      <b-card
        border-variant="dark"
        header="Secure Access Controls"
        header-bg-variant="dark"
        header-text-variant="white"
      >
        <h4>Controlled and Secure Access</h4>
        <b-card-text
          >Implement stringent access controls, ensuring that only
          authorized personnel can access sensitive medical data. Prioritize
          patient privacy and data security.</b-card-text
        >
      </b-card>
    </b-card-group>
    <b-card-group deck style="margin-top: 30px;margin-bottom: 40px;">
      <b-card
        border-variant="dark"
        header="Easy Sharing and Collaboration"
        header-bg-variant="dark"
        header-text-variant="white"
      >
        <h4>Share Data with a Click</h4>
        <b-card-text
          >Facilitate collaboration among healthcare teams by easily sharing
          relevant medical records and vital signs, ensuring comprehensive
          and coordinated care.</b-card-text
        >
      </b-card>
      <b-card
        border-variant="dark"
        header="Data Analytics and Insights"
        header-bg-variant="dark"
        header-text-variant="white"
      >
        <h4>Gain Insights from Medical Data</h4>
        <b-card-text
          >Utilize integrated data analytics tools to derive actionable
          insights from medical records and vital signs, driving darkrmed
          clinical decisions.</b-card-text
        >
      </b-card>
      <b-card style="border: none;"> </b-card>
    </b-card-group>
  </div>
  <!-- Benefit -->
  <div class="row">
<div class="col-lg-10 col-md-12 offset-lg-1">
<h3 class="text-center py-3 mt-3 mb-3">
  Empowering Healthcare with Digital Data Management
</h3>
<div class="row">
  <div class="col-md-4">
    <b-card border-variant="dark" header="Efficiency" header-bg-variant="dark" header-text-variant="white">
      <b-card-text>
        Access any medical record or vital sign data within seconds, streamlining the care process.
      </b-card-text>
    </b-card>
  </div>
  <div class="col-md-4">
    <b-card border-variant="dark" header="Accuracy" header-bg-variant="dark" header-text-variant="white">
      <b-card-text>
        Ensure accurate and up-to-date patient data, reducing potential errors in care delivery.
      </b-card-text>
    </b-card>
  </div>
  <div class="col-md-4">
    <b-card border-variant="dark" header="Security" header-bg-variant="dark" header-text-variant="white">
      <b-card-text>
        Store and manage all medical data securely, adhering to the highest standards of data protection.
      </b-card-text>
    </b-card>
  </div>
</div>
<div class="row mt-3">
  <div class="col-md-4">
    <b-card border-variant="dark" header="Collaboration" header-bg-variant="dark" header-text-variant="white">
      <b-card-text>
        Foster interdisciplinary collaboration with easy data sharing and access.
      </b-card-text>
    </b-card>
  </div>
  <div class="col-md-4"></div>
  <div class="col-md-4"></div>
</div>

<!-- Call to Action Section -->
<div class="mt-5 mb-4 text-center">
  <div class="col-lg-6 offset-lg-3">
    <b-card bg-variant="info" text-variant="white" title="" style="border: 1px solid black">
      <b-card-text>
        Step into the digital age of medical data management with {{main_data}}. Register now and revolutionize the way you store, access, and manage patient data!
      </b-card-text>
      <b-button href="#" variant="dark">
        Register Now
      </b-button>
    </b-card>
  </div>
</div>
</div>
</div>

</div>
</div>
<layout-footer></layout-footer>
</div>
</div>
</template>
<script>
import config from "../../services/CommonApi";
import axios from "axios";
export default {
  data() {
    return {
      main_data: "",
      config: config,
    };
  },
  mounted() {
    this.get_practitioner_profile();
  },
  methods: {

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].brand_name
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            }
            else if (window.location.hostname.startsWith("192.168")) {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }
          this.$swal.close();
        });
    },

  },
}
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/DigitalStroageMadicalRecords.vue